<template>
  <StepModel
    :ui="uiBaseStep"
    :name="STEP_NAMES.uploadIdentity"
    :ui-title="identityInfo"
    ui-subtitle="Upload a picture of your Emirates ID from your phone or laptop
    and we will automatically fill in the details from your ID.
    You can also skip this step and type the data from your Emirates ID manually."
    ui-error-message="Something went wrong when we tried to read your ID.
    Please upload again or enter your information manually."
    ui-secondary-button="or do it manually"
    :ui-secondary-action="goToNextStepWithoutValidate"
  >
    <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.upload" ui-columns="2">
      <UiWrapper
        :name="FIELD_NAMES.emiratesFrontCard"
        label="Upload the front of your ID"
        :max-file-size="15360"
      >
        <UploadWrapper
          :upload-service="readOCRAndChangeFields('front')"
          accept="image/jpeg, image/png"
          :changeable="true"
          id-side="front"
        />
      </UiWrapper>
      <UiWrapper
        :name="FIELD_NAMES.emiratesBackCard"
        label="Upload the back of your ID"
        :max-file-size="15360"
      >
        <UploadWrapper
          :upload-service="readOCRAndChangeFields('back')"
          accept="image/jpeg, image/png"
          :changeable="true"
          id-side="back"
        />
      </UiWrapper>
    </FieldsetModel>
  </StepModel>
</template>

<script>
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import uploadService from "@/forms/api/services/upload";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
// Components
import UploadWrapper from "@/forms/components/ui-dunia/upload-wrapper";
import UiWrapper from "@/forms/components/base/ui-wrapper";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import * as conditions from "@/forms/conditions";
export default {
  components: {
    UploadWrapper,
    StepModel,
    UiWrapper,
    FieldsetModel
  },

  mixins: [FormComponentMixin],
  data:()=>({
 identityInfo:"Identity Information",
  }),
  prop:{
    stepTitle:{
      type:String
    },
    subTitle:{
      type:String
    },
  },
  mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  methods: {
    readOCRAndChangeFields: uploadService.readOCRAndChangeFields
  }
};
</script>
